import type { HTTPValidationError, OptimizationModel } from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'
import type { AxiosError } from 'axios'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export const optimizationQueries = {
	single: (optimizationGroupId: string) => ({
		queryKey: ['optimization', optimizationGroupId],
		queryFn: () =>
			client.optimizations
				.getCurrentOptimizations({
					og_id: [optimizationGroupId],
				})
				.then((optimizations) => optimizations[0]),
	}),
	singleExact: (optimizationId: string) => ({
		queryKey: ['optimization-exact', optimizationId],
		queryFn: () =>
			client.optimizations
				.getOptimizations({ id: [optimizationId] })
				.then((optimizations) => optimizations[0]),
	}),
	list: () => ({
		queryKey: ['optimizations'],
		queryFn: () => client.optimizations.getCurrentOptimizations(),
	}),
}

export function useOptimizationsQuery<T = OptimizationModel[]>(
	options?: UseQueryOptions<
		OptimizationModel[],
		AxiosError<HTTPValidationError>,
		T
	>
) {
	return useQuery<OptimizationModel[], AxiosError<HTTPValidationError>, T>({
		...optimizationQueries.list(),
		...(options || {}),
	})
}
export function useOptimizationQuery<T = OptimizationModel>(
	optimizationGroupId: string,
	options?: UseQueryOptions<
		OptimizationModel,
		AxiosError<HTTPValidationError>,
		T
	>
) {
	return useQuery<OptimizationModel, AxiosError<HTTPValidationError>, T>({
		...optimizationQueries.single(optimizationGroupId),
		...(options || {}),
	})
}
